import type { ImageOptions } from '@lighthouse/core'

/**
 * 生成图片block的配置
 *
 * @returns {ImageOptions}
 */
export const generateImageBlock = (mainBreakPoint: string): ImageOptions => {
    return {
        sources: [],
        shape: 'rectangle',
        ratio: '0',
        radius: '8',
        fitType: 'cover',
        align: 'center',
        sourceType: 'default',
        autoPlay: false,
        swipeSpeed: 2,
        gridItemWidth: { size: 100, unit: 'px' },
        gridGap: { size: 10, unit: 'px' },
        listItemHeight: { size: 100, unit: 'px' },
        direction: 'vertical',
        eventList: [],
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'visible'
            },
            layout: {}
        },
        breakPoints: []
    }
}
